import { type FormConfig } from 'FormConfigs';
import { type PlayerViewModel } from 'Lessons';

export type HeaderLayout = 'default' | 'lesson-player' | 'lesson-editor';

export interface NavigationSectionConfig {
    name: NavigationSectionKey;
    isActive?: (section: NavigationSectionKey) => boolean;
    labelKey?: string;
    subsections?: FormConfig[];
    shouldBeVisible: () => boolean;
    onClick: (arg?: boolean) => void;
}

export enum NavigationSectionKey {
    application = 'application',
    application_status = 'application_status',
    account = 'account',
    my_profile = 'my-profile',
    billing = 'billing',
    preferences = 'preferences',
    documents = 'documents',
    sign_out = 'sign_out',
    faq = 'faq',
    switch_program = 'switch_program',
    support = 'support',
    grades = 'grades',
    select_program = 'select-program',
}

export type FrontRoyalRouteService = angular.route.IRouteService & {
    current: ExposedCurrentRouteService | undefined;
};

export type ExposedCurrentRouteService = angular.route.ICurrentRoute & {
    directive?: string | null;
    headerLayout?: HeaderLayout;
    useShell?: boolean;
    originalPath?: string | null;
};

export type AppHeaderViewModel = {
    setBodyBackground: (background?: string) => void;
    showAlternateHomeButton: boolean;
    setTitleHTML: (title: string, options?: { small?: boolean }) => void;
    hideMobileMenu: boolean;
    playerViewModel?: PlayerViewModel;
    learningBoxMode: {
        mode: 'playlists' | 'active_playlist' | 'course';
        hasSinglePlaylist?: boolean;
    } | null;
    hasTopMessage?: boolean;
    showCaret: boolean;
    toggleVisibility: (visible: boolean) => void;
};

export type LinkTarget = '_blank' | '_self' | '_parent' | '_top' | '_system';
